(() => {
  const configNode = document.getElementById('ab-currency-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  if (config.base !== 'USD') return;
  const preferenceKey = 'azure-display-currency-v1';
  const countryKey = 'azure-display-country-v1';
  const supported = new Set('USD EUR GBP CAD AUD NZD CHF JPY CNY HKD SGD TWD KRW AED SAR NOK SEK DKK PLN CZK HUF RON INR MYR THB IDR PHP MXN BRL ZAR TRY ILS'.split(' '));
  const countries = {AD:'EUR',AE:'AED',AS:'USD',AT:'EUR',AU:'AUD',AX:'EUR',BE:'EUR',BG:'EUR',BL:'EUR',BQ:'USD',BR:'BRL',BT:'INR',BV:'NOK',CA:'CAD',CC:'AUD',CH:'CHF',CK:'NZD',CN:'CNY',CX:'AUD',CY:'EUR',CZ:'CZK',DE:'EUR',DG:'USD',DK:'DKK',EA:'EUR',EC:'USD',EE:'EUR',ES:'EUR',EU:'EUR',FI:'EUR',FM:'USD',FO:'DKK',FR:'EUR',GB:'GBP',GF:'EUR',GG:'GBP',GL:'DKK',GP:'EUR',GR:'EUR',GS:'GBP',GU:'USD',HK:'HKD',HM:'AUD',HR:'EUR',HT:'USD',HU:'HUF',IC:'EUR',ID:'IDR',IE:'EUR',IL:'ILS',IM:'GBP',IN:'INR',IO:'USD',IT:'EUR',JE:'GBP',JP:'JPY',KI:'AUD',KR:'KRW',LI:'CHF',LS:'ZAR',LT:'EUR',LU:'EUR',LV:'EUR',MC:'EUR',ME:'EUR',MF:'EUR',MH:'USD',MP:'USD',MQ:'EUR',MT:'EUR',MX:'MXN',MY:'MYR',NA:'ZAR',NF:'AUD',NL:'EUR',NO:'NOK',NR:'AUD',NU:'NZD',NZ:'NZD',PA:'USD',PH:'PHP',PL:'PLN',PM:'EUR',PN:'NZD',PR:'USD',PS:'ILS',PT:'EUR',PW:'USD',RE:'EUR',RO:'RON',SA:'SAR',SE:'SEK',SG:'SGD',SI:'EUR',SJ:'NOK',SK:'EUR',SM:'EUR',SV:'USD',TA:'GBP',TC:'USD',TF:'EUR',TH:'THB',TK:'NZD',TL:'USD',TR:'TRY',TV:'AUD',TW:'TWD',UM:'USD',US:'USD',VA:'EUR',VG:'USD',VI:'USD',XK:'EUR',YT:'EUR',ZA:'ZAR',ZW:'USD'};
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key)); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch {} };
  let preference = 'auto';
  try { const saved = read(localStorage, preferenceKey); if (supported.has(saved)) preference = saved; } catch {}
  let active = 'USD';
  let region = config.country;
  let autoCurrency = countries[config.country] || 'USD';
  let request = 0;
  let ratePromise;
  let frame = 0;
  let failed = false;
  const status = document.createElement('p');
  status.className = 'ab-currency-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  document.body.append(status);

  function loadRates() {
    if (ratePromise) return ratePromise;
    ratePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
      script.async = true;
      script.referrerPolicy = 'no-referrer';
      const timer = setTimeout(() => reject(new Error('rates-timeout')), 8000);
      script.onload = () => {
        clearTimeout(timer);
        if (window.Currency?.rates?.USD === 1 && typeof window.Currency.convert === 'function') resolve(window.Currency);
        else reject(new Error('invalid-rates'));
      };
      script.onerror = () => { clearTimeout(timer); reject(new Error('rates-unavailable')); };
      document.head.append(script);
    }).catch(error => { ratePromise = undefined; throw error; });
    return ratePromise;
  }

  async function detectCountry(force = false) {
    try {
      const cached = read(sessionStorage, countryKey);
      if (!force && cached && Date.now() - cached.at < 3600000 && /^[A-Z]{2}$/.test(cached.country)) return cached.country;
    } catch {}
    const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
    const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {signal:AbortSignal.timeout(5000),credentials:'same-origin'});
    if (!response.ok) throw new Error('country-unavailable');
    const result = await response.json();
    const country = result.detected_values?.country?.handle || config.country;
    if (!/^[A-Z]{2}$/.test(country)) return config.country;
    try { write(sessionStorage, countryKey, {country,at:Date.now()}); } catch {}
    return country;
  }

  function render() {
    observer.disconnect();
    let formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:active,currencyDisplay:'code'}); } catch { active = 'USD'; }
    document.querySelectorAll('[data-ab-money]').forEach(element => {
      const amount = Number(element.dataset.abMoney);
      if (!Number.isFinite(amount) || element.dataset.abMoney === '') return;
      let text = element.dataset.abOriginal;
      if (active !== 'USD') {
        const converted = window.Currency.convert(amount / 100, 'USD', active);
        if (Number.isFinite(converted)) text = `~ ${formatter.format(converted)}`;
      }
      if (text !== undefined && element.textContent !== text) element.textContent = text;
    });
    document.querySelectorAll('[data-ab-currency-control]').forEach(control => {
      control.hidden = false;
      const select = control.querySelector('[data-ab-currency-select]');
      const automatic = select.querySelector('[value="auto"]');
      if (automatic) automatic.textContent = config.automatic;
      if (!control.open) select.value = active;
      const current = control.querySelector('[data-ab-currency-current]');
      if (current) current.textContent = active;
      const countrySelect = control.querySelector('[data-ab-country-select]');
      if (countrySelect) {
        [...countrySelect.options].forEach(option => {
          option.textContent = `${option.dataset.countryName} (${countries[option.value] || option.dataset.marketCurrency || 'USD'})`;
        });
        if (!control.open && [...countrySelect.options].some(option => option.value === region)) countrySelect.value = region;
      }
      control.querySelector('.ab-currency-note').textContent = failed ? config.unavailable : control.dataset.originalNote || control.querySelector('.ab-currency-note').textContent;
      if (!control.dataset.originalNote && !failed) control.dataset.originalNote = control.querySelector('.ab-currency-note').textContent;
    });
    document.querySelectorAll('[data-ab-currency-checkout]').forEach(note => { note.hidden = active === 'USD'; });
    observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['data-ab-money','data-ab-original']});
  }

  const observer = new MutationObserver(records => {
    if (!records.some(record => record.type === 'attributes' || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-ab-money],[data-ab-currency-control],[data-ab-currency-checkout]') || node.querySelector('[data-ab-money],[data-ab-currency-control],[data-ab-currency-checkout]'))))) return;
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; render(); });
  });

  async function update(next, manual = false) {
    const version = ++request;
    preference = supported.has(next) ? next : 'auto';
    if (manual) { try { write(localStorage, preferenceKey, preference); } catch {} }
    let currency = preference;
    if (preference === 'auto') {
      let detected;
      try { detected = await detectCountry(manual); } catch { detected = config.country; }
      if (version !== request) return;
      region = detected;
      autoCurrency = countries[region] || 'USD';
      currency = autoCurrency;
    }
    if (version !== request) return;
    let conversionFailed = false;
    if (currency !== 'USD') {
      try {
        const rates = await loadRates();
        if (!(rates.rates[currency] > 0) || !Number.isFinite(rates.rates[currency])) throw new Error('missing-rate');
      } catch { conversionFailed = true; currency = 'USD'; }
    }
    if (version !== request) return;
    failed = conversionFailed;
    active = currency;
    render();
    if (manual) status.textContent = failed ? config.unavailable : config.updated.replace('__currency__', active);
  }

  document.addEventListener('change', event => {
    if (event.target.matches('[data-ab-country-select]')) {
      const select = event.target.closest('[data-ab-currency-control]').querySelector('[data-ab-currency-select]');
      select.value = countries[event.target.value] || 'USD';
    }
    if (event.target.matches('[data-ab-currency-select]') && !event.target.closest('.ab-region-form')) update(event.target.value, true);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('.ab-region-form')) return;
    const control = event.target.closest('[data-ab-currency-control]');
    const country = control.querySelector('[data-ab-country-select]')?.value || config.country;
    const currency = control.querySelector('[data-ab-currency-select]').value;
    region = country;
    control.open = false;
    update(currency, true);
    if (country === config.country) {
      event.preventDefault();
      control.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    const summary = event.target.closest('[data-ab-currency-control] > summary');
    if (summary && !summary.parentElement.open) render();
    const automatic = event.target.closest('[data-ab-currency-auto]');
    if (automatic) {
      const control = automatic.closest('[data-ab-currency-control]');
      control.open = false;
      update('auto', true);
      control.querySelector('summary').focus();
    }
    document.querySelectorAll('details[data-ab-currency-control][open]').forEach(control => {
      if (!control.contains(event.target)) control.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('details[data-ab-currency-control][open]').forEach(control => {
      if (!control.contains(event.target)) control.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const control = event.target.closest('details[data-ab-currency-control][open]');
    if (!control) return;
    event.preventDefault();
    event.stopPropagation();
    control.open = false;
    control.querySelector('summary').focus();
  });
  window.addEventListener('storage', event => {
    if (event.key === preferenceKey) {
      let value; try { value = JSON.parse(event.newValue); } catch {}
      update(value);
    }
  });
  window.addEventListener('pageshow', () => render());
  render();
  update(preference);
})();
